/// <reference types="react-scripts" />

export const API_ENDPOINT =
  process.env.REACT_APP_ENDPOINT ??
  "http://clabsql.clamv.jacobs-university.de:30566/api/v1";
